module Meevo.Components.Filters {
    'use strict';

    const PurchaseOrderNoteLinkifyFilter = ($sce: ng.ISCEService, $sanitize: ng.sanitize.ISanitizeService) => {
        const linkifyFilter: any = (text: string) => {
            if (!text) return text;

            const linked = text.replace(/(https?:\/\/[^\s]+)/g, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">link</a>`;
            });

            return $sce.trustAsHtml($sanitize(linked));
        };

        return linkifyFilter;
    };

    PurchaseOrderNoteLinkifyFilter.$inject = ['$sce', '$sanitize'];

    angular.module('meevo.components.filters')
        .filter('meevoPurchaseOrderNoteLinkifyFilter', PurchaseOrderNoteLinkifyFilter);

}